(() => {
  const DURATION = 250;

  const initAccordion = (details) => {
    if (details.dataset.saAccordionInit) return;
    details.dataset.saAccordionInit = 'true';

    const summary = details.querySelector('summary');
    const content = details.querySelector('.sa-footer__accordion-content');
    if (!summary || !content) return;

    const mql = window.matchMedia('(min-width: 750px)');
    let animation = null;

    const forceDesktopOpen = () => {
      if (mql.matches) {
        details.open = true;
        details.style.height = '';
        details.style.overflow = '';
      }
    };

    summary.addEventListener('click', (e) => {
      if (mql.matches) { e.preventDefault(); return; }
      e.preventDefault();
      if (animation) animation.cancel();

      if (details.open) {
        const start = details.offsetHeight + 'px';
        const end = summary.offsetHeight + 'px';
        details.style.overflow = 'hidden';
        animation = details.animate(
          { height: [start, end] },
          { duration: DURATION, easing: 'ease' }
        );
        animation.onfinish = () => {
          details.open = false;
          details.style.height = '';
          details.style.overflow = '';
          animation = null;
        };
      } else {
        details.open = true;
        const start = summary.offsetHeight + 'px';
        const end = details.scrollHeight + 'px';
        details.style.overflow = 'hidden';
        animation = details.animate(
          { height: [start, end] },
          { duration: DURATION, easing: 'ease' }
        );
        animation.onfinish = () => {
          details.style.height = '';
          details.style.overflow = '';
          animation = null;
        };
      }
    });

    mql.addEventListener('change', forceDesktopOpen);
    forceDesktopOpen();
  };

  const initAll = () => {
    document.querySelectorAll('.sa-footer__accordion').forEach(initAccordion);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (e) => {
    if (e.target) e.target.querySelectorAll('.sa-footer__accordion').forEach(initAccordion);
  });
})();
